import { useEffect, useState } from "react"

/**
 * Used to declaratively determine if an element is in a CSS transition.
 *
 * Example:
 * CSS
 * .block {
 *   left: 0px;
 *   transition: left 300ms ease-in-out;
 * }
 *
 * .block.transitioning {
 *   background: red
 * }
 *
 * function Demo() {
 *   const [left, setLeft] = useState(0)
 *   const [transitioning, start] = useTransitionElement(elementReft)
 *
 *   const moveLeft = () => {
 *     start()
 *     setLeft(left + 100)
 *   }
 *
 *   let className = "block"
 *   if (transitioning) className += " transitioning"
 *
 *   return (
 *     <button className="transitioning" style={{ left }} onClick={moveLeft}>
 *       Move Left
 *     </button>
 *   )
 * }
 *
 * In this example, the "transitioning" class will be on the element after
 * clicking start for the transition period specified in the CSS, or 500ms,
 * whichever is shorter.
 */
export default (element, timeout = 500) => {
  const [transitioning, setTransitioning] = useState(false)

  const start = () => {
    setTransitioning(true)
    setTimeout(() => {
      setTransitioning(false)
    }, timeout)
  }

  const end = () => {
    setTransitioning(false)
  }

  useEffect(() => {
    if (!element) return
    element.addEventListener("transitionend", end)

    return () => {
      element.removeEventListener("transitionend", end)
    }
  }, [element])

  if (!element) return [false, start]

  return [transitioning, start]
}
